.container {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

.row,
.rowPast {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
  flex-wrap: wrap;
  padding: var(--tuna-spacing-1) 0;
}

.rowPast {
  opacity: 0.55;
}

.label {
  min-width: 10rem;
  color: var(--tuna-content-primary);
  font-size: var(--tuna-typography-body1-fontSize);
}

.passed {
  padding: 0 var(--tuna-spacing-1);
  border: 1px solid var(--tuna-border-subtle);
  border-radius: var(--tuna-shape-borderRadius);
  color: var(--tuna-content-muted);
  font-size: var(--tuna-typography-body2-fontSize);
}

.tally {
  display: inline-flex;
  gap: var(--tuna-spacing-1);
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-body2-fontSize);
}

.maybe {
  color: var(--tuna-feedback-warning-text);
}

.meta {
  display: inline-flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
}

.avatars {
  display: inline-flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
  /* Reserved so a row with no yes-voters is exactly as tall as one with them. */
  min-height: 24px;
}

.notice {
  color: var(--tuna-content-secondary);
}

/* Skeletons sit at the final row height so nothing shifts when the data lands. */
.skeleton {
  height: 44px;
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-palette-action-hover);
  animation: pulse 1.4s ease-in-out infinite;
}

@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton {
    animation: none;
  }
}

/* The single-column list IS the mobile layout; nothing switches at the breakpoints. */
@media (max-width: 599.95px) {
  .row,
  .rowPast {
    align-items: flex-start;
    flex-direction: column;
  }
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
